module.exports = __webpack_public_path__ + "assets/img/bg_user_table.bc82b587.png";